import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-notation",
    styleUrls: ["./notation.component.scss"],
    templateUrl: "./notation.component.html",
    standalone: false
})
export class FUINotationComponent {
    @Input() public title: string;

}
